import { jsx as _jsx } from "react/jsx-runtime";
import { Box as MaterialBox } from '@material-ui/core';
/**
 * Re-exporting as FC type in order to properly render this component in source views within Storybook.
 */
export const Box = (props) => _jsx(MaterialBox, Object.assign({}, props, { children: props.children }), void 0);
//# sourceMappingURL=Box.js.map